var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallVifly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#395BA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74435 6.32202C3.35403 5.64315 3.58794 4.77639 4.26682 4.38606C4.9457 3.99574 5.81246 4.22965 6.20278 4.90853L9.28257 10.2651C9.6729 10.9439 9.43898 11.8107 8.76011 12.201C8.08123 12.5914 7.21447 12.3574 6.82414 11.6786L3.74435 6.32202Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3235 7.37357C8.65762 6.66534 9.5026 6.36205 10.2108 6.69616C10.9191 7.03028 11.2224 7.87527 10.8883 8.5835L9.58792 11.3399C9.25381 12.0481 8.40882 12.3514 7.70058 12.0173C6.99235 11.6832 6.68906 10.8382 7.02317 10.13L8.3235 7.37357Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4443 5.02777C12.4443 5.81086 11.8095 6.44568 11.0264 6.44568C10.2433 6.44568 9.60849 5.81086 9.60849 5.02777C9.60849 4.24468 10.2433 3.60986 11.0264 3.60986C11.8095 3.60986 12.4443 4.24468 12.4443 5.02777Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallVifly);
export default __webpack_public_path__ + "static/media/small_vifly.c18749cc141e65ef47015453fe3838b8.svg";
export { ForwardRef as ReactComponent };